/**
 * reece accordion
 */
export const accordion = (function() {
  'use strict';

  var init = function () {
    var accordions = document.querySelectorAll(".accordion__trigger");

    for(var i = 0; i < accordions.length; i ++) {
      // temporary functions
      accordions[i].onclick = handleAccordionTrigger;
    }
  };


  /**
   * handleAccordionTrigger
   * @param {*} e
   */
  var handleAccordionTrigger = function (e) {
    e.stopPropagation();

    var self = e.currentTarget;
    var sibling = self.parentElement.querySelector(".accordion__trigger + .accordion__drawer");

    sibling.classList.toggle("active");
    if (sibling.classList.contains("active")) {
      self.classList.add("active");
    }
    else {
      self.classList.remove("active");
    }


  };

  return {
    init: init
  };
});
